import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/ramana-steel-logo1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/updatedteam1.jpeg';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import AboutMain from './AboutMain';
import SEOHelmet from '../../components/SEO/SEOHelmet';


// Breadcrumbs Background Image

const About = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
            <SEOHelmet 
                title="About Ramana Steels | Leaders in Scrap Processing Solutions"
                description="Learn about Ramana Steels, a leading provider of innovative scrap processing and recycling equipment. Over years of expertise in the industry."
                keywords="about ramana steels, scrap processing company, recycling solutions, steel industry"
                canonicalUrl="https://ramanasteels.com/about"
            />
            <Header
                navImg={navImg1}
                parentMenu='about'
                activeMenu="/about"
            />
            {/* SiteBreadcrumb */}
            <SiteBreadcrumb
                pageTitle="About US"
                pageName="About US"
                breadcrumbsImg={bannerbg}
            />
            {/* SiteBreadcrumb */}
            <AboutMain />
            {/*cta-section */}
            {/* <CtaTwo /> */}
            {/*cta-section end */}
            <BackToTop scroll={isVisible} />
            <FooterTwo />
        </React.Fragment>
    );
}

export default About;